import ForecastChartContainer from 'legacy/containers/property-explorer-forecast-chart';

import { ForecastSection as theme } from 'legacy/css-modules';

const ForecastSection = () => {
  return (
    <ForecastChartContainer
      key="forecast-chart"
      className={theme.Chart}
      spinnerClassName={theme.LoadingSpinner}
      chartKey="valueForecastChart"
    />
  );
};

export default ForecastSection;
